import { render, staticRenderFns } from "./BaseEntryContentView.vue?vue&type=template&id=52dc5fb4&"
import script from "./BaseEntryContentView.vue?vue&type=script&lang=ts&"
export * from "./BaseEntryContentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports